/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconBatteryWhite: {
  name: 'battery_white';
  data: string;
} = {
  name: 'battery_white',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M160.943 220.208c-1.987 0-3.586 1.066-3.586 2.391v1.195h-3.586c-2.355 0-4.781 2.427-4.781 4.781v25.102c0 2.355 2.427 4.781 4.781 4.781h19.125c2.355 0 4.781-2.427 4.781-4.781v-25.102c0-2.355-2.427-4.781-4.781-4.781h-3.586v-1.195c0-1.324-1.599-2.391-3.586-2.391h-4.781zm-7.172 8.368h19.125v25.102h-19.125v-25.102zm9.562 2.39v8.367h-5.977l5.977 11.953v-8.367h5.977l-5.977-11.953z" transform="matrix(15 0 0 15 -2144 -3284)"/></svg>`,
};
